import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "conhecimentos",
  class: "skills-section"
}
const _hoisted_2 = { class: "section-title" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "container skills-grid" }
const _hoisted_6 = { class: "section-subtitle" }
const _hoisted_7 = { class: "skills-list" }

import { useLocalized } from '@/composables/useLocalized';
import { skillGroups } from '@/data/skills';


export default /*@__PURE__*/_defineComponent({
  __name: 'SkillsSection',
  setup(__props) {

const { pick } = useLocalized();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('sections.skills')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('skills.intro')), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('skills.practices')), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(skillGroups), (group) => {
        return (_openBlock(), _createElementBlock("div", {
          key: group.id,
          class: "col"
        }, [
          _createElementVNode("h3", _hoisted_6, _toDisplayString(_unref(pick)(group.i18n).title), 1),
          _createElementVNode("ul", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.skills, (skill) => {
              return (_openBlock(), _createElementBlock("li", {
                key: skill.id,
                class: "conhecimento"
              }, _toDisplayString(_unref(pick)(skill.i18n).name), 1))
            }), 128))
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})